import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type CarouselCard = {
  caption: string;
  subCaption: string;
  staticImgPath: string;
}

export type CarouselData = {
  cards: CarouselCard[]
  header: string;
  subHeader: string;
}

@Component({
  selector: 'blinker',
  templateUrl: './blinker.component.html',
  styleUrls: ['./blinker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlinkerComponent {
  @Input() display: string = "inline-block";
  @Input() paddingRight: number = 8;
  @Input() marginTop: number = 0;
}